import { NumberUtils } from "neo-common";
import { Configuration } from "../../../Components/Configuration";
import { HtmlController } from "../../../HTMLComponents/HtmlController";
import { PlayList } from "../../../Components/Sounds/PlayList";
import { RouletteBetConfiguration } from "../../../CustomComponents/RouletteBetConfiguration";
import { GameData } from "../Datas/GameData";
import { Languages } from "../../../Utils/Languages";
import { DataManager } from "../../../Managers/DataManager";
import { UserAction } from "../../../HTMLComponents/UserAction";
import { ModuleManager } from "../../../Managers/ModuleManager";
import { FreeRoundBonus } from "../Bonuses/FreeRoundBonus";
import { GameManager } from "../../../Managers/GameManager";
import { Game } from "neo-games/Engine/Communication/index";
import { AppContext } from "../../../../Common/AppContext";
import { Platforms } from "neo-games";
import { RouletteActions } from "../Actions/RouletteActions";

export class Paytable {
    static Configurations = {
        PAYTABLE_COUNT_PREFIX: "",
        PAYTABLE_COUNT_POSTFIX: "",
        PAYTABLE_VALUE_PREFIX: "",
        PAYTABLE_VALUE_POSTFIX: "x",
    };

    public static instance: Paytable;
    public static userClosedPaytableAtStart: boolean = false;

    private static hasBeenDisplayed: boolean = false;
    private static payoutPage: number = -1;

    private _pages: HTMLCollectionOf<Element>;
    private _paginations: HTMLCollectionOf<Element>;

    constructor() {
        Paytable.instance = this;
    }

    initialize(): void {
        let prewPageButton: HTMLElement = document.getElementById("paytableButtonLeft");
        let nextPageButton: HTMLElement = document.getElementById("paytableButtonRight");

        if (prewPageButton != null) {
            prewPageButton.onclick = this.prewPage.bind(this);
        }

        if (nextPageButton != null) {
            nextPageButton.onclick = this.nextPage.bind(this);
        }

        this._pages = document.getElementsByClassName("paytablePage");
        this._paginations = document.getElementsByClassName("paytablePageNumber");

        if (GameManager.rouletteResponse && GameManager.rouletteResponse.initData.compensationEnabled == false) {
            let zeroPayoutElements = document.getElementsByClassName("zeroPayout");

            for (let i = zeroPayoutElements.length - 1; i >= 0; i--) {
                zeroPayoutElements[i].classList.remove("zeroPayout");
            }
        }

        this.createSingleBetLimits();
    }

    private createSingleBetLimits(): void {
        let config: Element = Configuration.Configurations["SingleBetLimitConfiguration"];
        let singleBetLimit = parseFloat(DataManager.SingleBetLimit);
        let multiplier = 1;

        if (config != null) {
            let types = RouletteBetConfiguration.AllTypes;

            for (let i = 0; i < types.length; i++) {
                let type = types[i];

                if (config.hasAttribute(type)) {
                    multiplier = parseInt(config.getAttribute(type));

                    DataManager.updateGameDataFromModule(
                        GameData.DataSingleBetLimit + type,
                        Languages.formatText(Languages.FormatMoney, NumberUtils.multiply(singleBetLimit, multiplier)) +
                            " " +
                            DataManager.getDataById(GameData.DataCurrency),
                    );
                    DataManager.updateDataElement(
                        GameData.DataSingleBetLimit + type,
                        Languages.formatText(Languages.FormatMoney, NumberUtils.multiply(singleBetLimit, multiplier)) +
                            " " +
                            DataManager.getDataById(GameData.DataCurrency),
                    );
                }
            }
        }
    }

    private prewPage(): void {
        let activeIndex: number = this.disableElementsAndReturnActive();
        if (this._pages != null) {
            if (activeIndex === 0) {
                this._pages[this._pages.length - 1].classList.remove("_disabled");
                this._pages[this._pages.length - 1].classList.add("_active");
            } else {
                this._pages[activeIndex - 1].classList.remove("_disabled");
                this._pages[activeIndex - 1].classList.add("_active");
            }
            PlayList.play("SND_Click");
        }
        if (this._paginations != null) {
            if (activeIndex === 0) {
                this._paginations[this._paginations.length - 1].classList.remove("_disabled");
                this._paginations[this._paginations.length - 1].classList.add("_active");
            } else {
                this._paginations[activeIndex - 1].classList.remove("_disabled");
                this._paginations[activeIndex - 1].classList.add("_active");
            }
        }
    }

    private nextPage(): void {
        let activeIndex: number = this.disableElementsAndReturnActive();
        if (this._pages != null) {
            if (activeIndex === this._pages.length - 1) {
                this._pages[0].classList.remove("_disabled");
                this._pages[0].classList.add("_active");
            } else {
                this._pages[activeIndex + 1].classList.remove("_disabled");
                this._pages[activeIndex + 1].classList.add("_active");
            }
            PlayList.play("SND_Click");
        }
        if (this._paginations != null) {
            if (activeIndex === this._paginations.length - 1) {
                this._paginations[0].classList.remove("_disabled");
                this._paginations[0].classList.add("_active");
            } else {
                this._paginations[activeIndex + 1].classList.remove("_disabled");
                this._paginations[activeIndex + 1].classList.add("_active");
            }
        }
    }

    private setPage(page: number): void {
        if (page < 0 || page > this._pages.length - 1) {
            return;
        }

        this.disableElementsAndReturnActive();
        if (this._pages != null) {
            this._pages[page].classList.remove("_disabled");
            this._pages[page].classList.add("_active");
            (this._pages[page] as HTMLElement).scrollIntoView();
        }

        if (this._paginations != null) {
            this._paginations[page].classList.remove("_disabled");
            this._paginations[page].classList.add("_active");
        }
    }

    private disableElementsAndReturnActive(): number {
        let activeIndex: number = 0;
        for (var i: number = 0; i < this._pages.length; i++) {
            var element: HTMLElement = <HTMLElement>this._pages[i];
            if (element != null) {
                if (!element.classList.contains("_disabled")) {
                    element.classList.add("_disabled");
                }
                if (element.classList.contains("_active")) {
                    activeIndex = i;
                    element.classList.remove("_active");
                }
            }
        }

        for (var i: number = 0; i < this._paginations.length; i++) {
            var element: HTMLElement = <HTMLElement>this._paginations[i];
            if (element != null) {
                if (!element.classList.contains("_disabled")) {
                    element.classList.add("_disabled");
                }
                if (element.classList.contains("_active")) {
                    element.classList.remove("_active");
                }
            }
        }

        return activeIndex;
    }

    public static openAtStart(newGameRound: boolean = false): void {
        if (Paytable.shouldOpen(newGameRound)) {
            Paytable.show();
        }
    }

    public static show(): void {
        Paytable.hasBeenDisplayed = true;

        let dipatchElementId = UserAction.ActionPaytableOn;
        if (HtmlController.UiDispatchElements[dipatchElementId]) {
            let dipatchElement = HtmlController.UiDispatchElements[dipatchElementId][0];

            if (dipatchElement != null) {
                if (dipatchElement.instance.classList.contains(HtmlController.DisabledClass)) {
                    HtmlController.dispatchUiAction(UserAction.ActionPaytableOn);
                }
            }
        }

        Paytable.openPayoutPage();
        window.addEventListener("resize", Paytable.openPayoutPage);
    }

    public static close(action: string = ""): void {
        Paytable.clearListeners();

        const peakApp = document.querySelector("peak-app");
        const hasPendingNotifications =
            peakApp &&
            peakApp.hasAttribute("pending-notifications-count") &&
            parseInt(peakApp.getAttribute("pending-notifications-count")!) > 0;
        if (
            Paytable.hasBeenDisplayed &&
            !Paytable.userClosedPaytableAtStart &&
            AppContext.gameConfiguration.ShowPaytableAtStart
        ) {
            Paytable.userClosedPaytableAtStart = true;
            if (action == RouletteActions.ActionAutoplay || action == RouletteActions.ActionSpin) {
                if (hasPendingNotifications) {
                    Platforms.Platforms.gamePlaySupressSpinOnCollect();
                }
            } else {
                Platforms.Platforms.roundInit();
            }
        }
    }

    private static openPayoutPage(): void {
        Paytable.instance.setPage(Paytable.payoutPage);
    }

    public static clearListeners(): void {
        window.removeEventListener("resize", Paytable.openPayoutPage);
    }

    public static shouldOpen(newGameRound: boolean = false, isSpin: boolean = false): boolean {
        if (!AppContext || !AppContext.gameConfiguration.ShowPaytableAtStart) {
            return false;
        }

        //if prepareNewGameRound was called before GameManager.showGame, ignore hasBeenDisplayed
        if (Paytable.hasBeenDisplayed && newGameRound) {
            return false;
        }

        if (!DataManager.GameRoundClosed && !isSpin) {
            return false;
        }

        if (FreeRoundBonus.isLastFrb) {
            return false;
        }

        return true;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/Paytable/Paytable.ts
 **/